import * as React from "react";

const Video = ({ videoUrl, type = 'video/mp4' }) => {
    return (
        <video width={'100%'} autoPlay={true} muted={true} loop>
            <source src={videoUrl} type={type}/>
            Your browser does not support the video tag.
        </video>
    );
};

export default Video;